<template>
  <div class="container-fluid text-left">
    <div class="col-12">
      <div class="row tt_x_10 tt_10 b_x">
        <div class="col-3 middle col-00">
          <h4 class="z_15">服务项目</h4>
        </div>
        <div class="col-9 middle col-00">
          <input
            class="z_15"
            type="text"
            placeholder="填写服务项目"
            name=""
            id=""
            v-model="project"
          />
        </div>
      </div>
      <div class="row tt_x_10 tt_10 b_x">
        <div class="col-3 middle col-00">
          <h4 class="z_15">服务时间</h4>
        </div>
        <div class="col-9 middle col-00">
          <input
            class="z_15"
            type="text"
            placeholder="填写服务时间"
            name=""
            id=""
            v-model="time"
          />
        </div>
      </div>
      <div class="row tt_x_10 tt_10 b_x">
        <div class="col-3 middle col-00">
          <h4 class="z_15">服务人群</h4>
        </div>
        <div class="col-9 middle col-00">
          <input
            class="z_15"
            type="text"
            placeholder="填写服务人群"
            name=""
            id=""
            v-model="crowd"
          />
        </div>
      </div>
      <div
        class="row b_x"
        style="height: 57px; line-height: 57px"
        @click="Jump()"
      >
        <div class="col-3 middle col-00" style="flex: 9">
          <h4 class="z_15" style="width: 300px; display: flex">
            <span style="display: block; width: 135px">所在位置</span>
          </h4>
        </div>
        <div class="col-8 middle col-00">
          <span
            style="
              display: block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
            >{{ location ? location : "" }}</span
          >
        </div>
        <div class="text-right middle" style="padding-right: 10px; flex: 1">
          <h6><samp class="glyphicon glyphicon-chevron-right"></samp></h6>
        </div>
      </div>
      <div class="col-12">
        <button class="submit_btn" @click="submit">提交资料</button>
      </div>
    </div>
    <div id="d_p_80" style="height: 20px"></div>
    <h3>服务列表</h3>
    <div v-for="(item, index) in olist" :key="index">
      <div class="col-12">
        <!-- <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">服务分类</h4>
          </div>
          <div class="col-9 middle col-00">
            <select v-model="item.entry_type">
              <option v-for="(option,aa) in options" :key="aa" v-bind:value="option.value">
                {{ option.text }}
              </option>
            </select>
          </div>
        </div> -->
        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">服务项目</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="填写服务项目"
              name=""
              id=""
              v-model="item.entry_name"
            />
          </div>
        </div>

        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">服务时间</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="填写服务时间"
              name=""
              id=""
              v-model="item.entry_time"
            />
          </div>
        </div>

        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">服务对象</h4>
          </div>
          <div class="col-9 middle col-00">
            <input
              class="z_15"
              type="text"
              placeholder="填写服务人群"
              name=""
              id=""
              v-model="item.entry_people"
            />
          </div>
        </div>

        <div class="row tt_x_10 tt_10 b_x">
          <div class="col-3 middle col-00">
            <h4 class="z_15">服务状态</h4>
          </div>
          <div class="col-9 middle col-00">
            <select style="outline: none" v-model="item.state">
              <option value="1">开启</option>
              <option value="2">关闭</option>
            </select>
          </div>
        </div>

        <div class="row tt_x_10 tt_10 b_x" @click="editJump(index, item)">
          <div class="col-3 middle col-00" style="flex: 9">
            <h4 class="z_15" style="width: 300px; display: flex">
              <span style="display: block; width: 135px">所在位置</span>
            </h4>
          </div>
          <div class="col-8 middle col-00">
            <span
              style="
                display: block;
                margin: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
              >{{ item.entry_address ? item.entry_address : "" }}</span
            >
          </div>
          <div class="text-right middle" style="padding-right: 10px; flex: 1">
            <h6><samp class="glyphicon glyphicon-chevron-right"></samp></h6>
          </div>
        </div>

        <div class="col-12">
          <button class="submit_btn" @click="edit(item)">修改</button>
        </div>
      </div>
      <div id="d_p_80" style="height: 20px"></div>
    </div>
    <div id="d_p_80"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showji: false,
      selected: "",
      options: [
        {
          text: "生活服务",
          value: "1",
        },
        {
          text: "文化服务",
          value: "2",
        },
        {
          text: "帮扶服务",
          value: "3",
        },
      ],
      classification: "",
      project: "",
      time: "",
      community: "",
      crowd: "",
      olist: [],
      location: "",
      location1: "",
      center1: [],
      center2: [],
    };
  },
  components: {},
  mounted() {
    this.list();
  },
  methods: {
    Jump() {
      this.$router.push({
        name: "location",
        query: {
          name: this.location,
          center1: this.$route.query.center1,
          ro: "1",
        },
      });
      // content:project,money:time,name1:crowd
      window.localStorage.setItem("project", this.project);
      window.localStorage.setItem("time", this.time);
      window.localStorage.setItem("crowd", this.crowd);
    },
    editJump(index, item) {
      let ff = item.entry_address_xy;
      // this.center = [121.442874, 28.673348]
      if (typeof ff == "string") {
        ff = ff.split(",");
      }
      this.$router.push({
        name: "location1",
        query: { id: item.id, center: ff, name: item.entry_address, ro: "1" },
      });
      window.localStorage.setItem("index", index);
      window.localStorage.setItem("state", item.state);
      window.localStorage.setItem("entry_people", item.entry_people);
      window.localStorage.setItem("entry_time", item.entry_time);
      window.localStorage.setItem("entry_name", item.entry_name);
    },
    edit(item) {
      // console.log(id, entry_address, entry_name, entry_time, entry_community, entry_people);
      let data = new FormData();
      // data.append('id', id)
      // data.append('entry_type', entry_type)
      data.append("entry_name", item.entry_name);
      data.append("entry_time", item.entry_time);
      //data.append('openid', 2354414)
      data.append("openid", this.$api.getUserInfo().openid);
      data.append("ojb_id", this.$api.getUserInfo().id);
      data.append("entry_people", item.entry_people);
      data.append("entry_address", item.entry_address);
      data.append("entry_address_xy", item.entry_address_xy);
      data.append("state", item.state);
      // console.log(this.$route.query.center);
      // console.log(this.center);
      // console.log(entry_address, this.$route.query.center);
      this.$api
        .postAPI(
          `mutual/server/` +
            item.id +
            "?appid=202108&type_id=2001&state=1&redis_time=2",
          data
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("设置完成");
            console.log(res);
          }
        });
    },
    list() {
      //const info = user_model.getUserinfo()
      this.$api
        .getAPI("mutual/server/", {
          appid: 202108,
          type_id: 2001,
          ojb_id: this.$api.getUserInfo().id,
        })
        .then((res) => {
          // console.log(res.data.data);
          // console.log(res.data.data[0].models);
          this.olist = res.data.data.data[0].models;
          // console.log(this.olist);
          // console.log(this.$route.query.id);
          if (
            this.$route.query.id != undefined &&
            window.localStorage.getItem("index") != null
          ) {
            this.olist[window.localStorage.getItem("index")].entry_address =
              this.$route.query.name;
            this.olist[window.localStorage.getItem("index")].entry_name =
              window.localStorage.getItem("entry_name");
            this.olist[window.localStorage.getItem("index")].state =
              window.localStorage.getItem("state");
            this.olist[window.localStorage.getItem("index")].entry_people =
              window.localStorage.getItem("entry_people");
            this.olist[window.localStorage.getItem("index")].entry_time =
              window.localStorage.getItem("entry_time");
            // this.center2 = this.$route.query.center
            this.olist[window.localStorage.getItem("index")].entry_address_xy =
              this.$route.query.center.join(",");
            console.log(
              this.olist[window.localStorage.getItem("index")].entry_address_xy
            );
            window.localStorage.removeItem("index");
            window.localStorage.removeItem("entry_name");
            window.localStorage.removeItem("entry_people");
            window.localStorage.removeItem("entry_time");
            window.localStorage.removeItem("state");
          } else if (this.$route.query.id == undefined) {
            // console.log(this.$route.query.center1);
            this.center1 = this.$route.query.center1;
            // this.center1 = this.center1.join(",")
            this.location = this.$route.query.name;
            if (window.localStorage.getItem("project") != null) {
              this.project = window.localStorage.getItem("project");
            }
            if (window.localStorage.getItem("time") != null) {
              this.time = window.localStorage.getItem("time");
            }
            if (window.localStorage.getItem("crowd")) {
              this.crowd = window.localStorage.getItem("crowd");
            }
            // console.log(this.center1);
            window.localStorage.removeItem("project");
            window.localStorage.removeItem("time");
            window.localStorage.removeItem("crowd");
          }
        });
    },
    submit() {
      let data = new FormData();
      //const info = user_model.getUserinfo()
      // data.append('entry_type', this.selected)
      data.append("entry_name", this.project);
      data.append("entry_time", this.time);
      // data.append('entry_community', this.community)
      data.append("openid", this.$api.getUserInfo().openid);
      data.append("ojb_id", this.$api.getUserInfo().id);
      data.append("entry_people", this.crowd);
      //data.append('entry_amount', entry_amount)
      data.append("entry_address", this.location);
      data.append("entry_address_xy", this.center1.join(","));
      data.append("state", 1);
      if (this.center1 == undefined) {
        this.$Message.error("请选择所在位置！");
        return;
      }
      // console.log(this.location, this.$route.query.center);
      this.$api
        .postAPI(`mutual/server/?appid=202108&type_id=2001&state=1`, data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("设置完成");
            this.$router.push("/home_users");
          }
        });
      // this.$axios.post('app/mutual/server/?appid=202108&type_id=2001',
      //   {
      //     'openid': 2354414,
      //     'entry_type': this.selected,
      //     'entry_name': this.project,
      //     'entry_time': this.time,
      //     'entry_community': this.community,
      //     'entry_people': this.crowd
      //   }, {
      //   headers: {
      //     "Content-Type": "application/x-www-form-urlencoded"
      //   }
      // }).then(res => {
      //   if (res.data.code == 200) {
      //     alert('设置完成')
      //     this.$router.push('/')
      //     console.log(res);
      //   }
      // })
      // console.log(this.selected, this.classification, this.project, this.time, this.community, this.crowd);
    },
  },
};
</script>

<style>
.submit_btn {
  margin-top: 20px;
  bottom: 0;
  width: 100%;
  border: 0;
  text-align: center;
  line-height: 3em;
  font-size: 1em;
  color: #ffffff;
  background: #01b2c2;
  cursor: pointer;
  margin-left: 0;
  height: auto;
}

.col-00 {
  padding-right: 0px;
  padding-left: 0px;
}

textarea {
  padding: 8px;
  border: 1px dashed #e5e5e5;
}

select {
  border-radius: 5px;
  border: 1px solid #777;
}

.add_btn {
  width: 80px;
  height: 80px;
  border: 1px dashed #e5e5e5;
  background: url(https://www.17sucai.com/preview/61021/2020-01-20/%E5%B8%A6%E7%BC%A9%E7%95%A5%E5%9B%BE%E7%9A%84%E5%9B%BE%E7%89%87%E4%B8%8A%E4%BC%A0/imgs/add.png)
    no-repeat 50% 50%;
  cursor: pointer;
}

.wz {
  display: inline-block;
  width: 145px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/server_project_release.vue